import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetLoanCalculationsB2CTransactionsUseCase extends UseCase {
  constructor({loanCalculationsB2CTransactionsRequest, getLoanCalculationsB2CTransactionsService}) {
    super()
    this._loanCalculationsB2CTransactionsRequest = loanCalculationsB2CTransactionsRequest
    this._getLoanCalculationsB2CTransactionsService = getLoanCalculationsB2CTransactionsService
  }

  @inlineError
  async execute({adId, entry, terms, withLifeInsurance, lender}) {
    const loanCalculationsB2CParams = this._loanCalculationsB2CTransactionsRequest({
      adId,
      entry,
      terms,
      withLifeInsurance,
      lender
    })

    const [error, response] = await this._getLoanCalculationsB2CTransactionsService.execute(loanCalculationsB2CParams)

    if (error) return Promise.reject(error)
    return response.toJSON()
  }
}
